import { __spreadArrays } from "tslib";
import React, { useState } from 'react';
import InternalBox from '../box/internal';
import { InternalButton } from '../button/internal';
import InternalCheckbox from '../checkbox/internal';
import InternalColumnLayout from '../column-layout/internal';
import InternalFormField from '../form-field/internal';
import InternalModal from '../modal/internal';
import InternalSelect from '../select/internal';
import InternalSpaceBetween from '../space-between/internal';
import { LightThemes, DarkThemes } from './ace-themes';
export default (function (props) {
    var _a, _b, _c, _d;
    var _e = useState((_b = (_a = props.preferences) === null || _a === void 0 ? void 0 : _a.wrapLines) !== null && _b !== void 0 ? _b : true), wrapLines = _e[0], setWrapLines = _e[1];
    var _f = useState((_d = (_c = props.preferences) === null || _c === void 0 ? void 0 : _c.theme) !== null && _d !== void 0 ? _d : props.defaultTheme), theme = _f[0], setTheme = _f[1];
    var _g = useState(function () { return __spreadArrays(LightThemes, DarkThemes).filter(function (t) { return t.value === theme; })[0]; }), selectedThemeOption = _g[0], setSelectedThemeOption = _g[1];
    var onThemeSelected = function (e) {
        setTheme(e.detail.selectedOption.value);
        setSelectedThemeOption(e.detail.selectedOption);
    };
    return (React.createElement(InternalModal, { visible: true, onDismiss: props.onDismiss, header: props.i18nStrings.header, closeAriaLabel: props.i18nStrings.cancel, footer: React.createElement(InternalBox, { float: "right" },
            React.createElement(InternalSpaceBetween, { direction: "horizontal", size: "xs" },
                React.createElement(InternalButton, { onClick: props.onDismiss }, props.i18nStrings.cancel),
                React.createElement(InternalButton, { onClick: function () { return props.onConfirm({ wrapLines: wrapLines, theme: theme }); }, variant: "primary" }, props.i18nStrings.confirm))) },
        React.createElement(InternalColumnLayout, { columns: 2, variant: "text-grid" },
            React.createElement("div", null,
                React.createElement(InternalCheckbox, { checked: wrapLines, onChange: function (e) { return setWrapLines(e.detail.checked); } }, props.i18nStrings.wrapLines)),
            React.createElement("div", null,
                React.createElement(InternalFormField, { label: props.i18nStrings.theme },
                    React.createElement(InternalSelect, { selectedOption: selectedThemeOption, onChange: onThemeSelected, options: [
                            { label: props.i18nStrings.lightThemes, options: LightThemes },
                            { label: props.i18nStrings.darkThemes, options: DarkThemes }
                        ], filteringType: "auto" }))))));
});
//# sourceMappingURL=preferences-modal.js.map